<template>
  <div>
    <p class="font-md">These are notifications that have a start date in the future.</p>
    <p class="font-md font-weight-bold">Once the start date is reached, these notifications will become active.</p>
    <PaginatedTable ref='pNTable'
      :fields="fields"
      :key="tableKey"
      :busy="isBusy"
      tableId="scheduledNotificationsTable"
      noResultsText="You have no Scheduled Notifications."
      url="/notification/myScheduledNotifications"
    >
      <template v-slot:head()="data">
        {{data.label}}
      </template>
      <template  #table-busy>
        <LoadingSpinner  :message="`Loading Scheduled Notifications`" />
      </template>
      <template v-slot:cell(townName)="data">
        <div class="mobile-row-center">
          {{data.item.townName}}
        </div>
      </template>
      <template v-slot:cell(operationDate)="data">
        <div class="mobile-row-center">
          {{data.item.operationStartDate | dateString}}
          -
          {{data.item.operationEndDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(activities)="data">
        <div class="mobile-row-center">
          {{data.value}}
        </div>
      </template>
      <template v-slot:cell(view)="data">
        <div class="text-right mobile-row-center">
          <router-link tag="a" size="sm" :to="`/notification/${data.item.id}`">
            View
          </router-link>
        </div>
      </template>
    </PaginatedTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PaginatedTable from '@/components/common/PaginatedTable.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'MyScheduledNotifications',
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: 'townName', label: 'Town' },
        { key: 'statusName', label: 'Status' },
        { key: 'operationDate', label: 'Operation Start/End Date' },
        { key: 'activities', label: 'Activities', formatter: this.activitiesString },
        { key: 'view', label: '', stickyColumn: true },
      ],
      tableKey: 0,
    };
  },
  computed: {
    ...mapState(['isExtraSmall']),
    ...mapState('Notification', {
      fonDeleteError: state => state.fonDeleteError,
    }),
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        // move actionField in front of basic fields
        this.shiftMobile();
      } else {
        // move actionField to end of basic fields
        const actionField = this.fields.shift();
        this.fields.push(actionField);
      }
    },
  },
  methods: {
    activitiesString(value, key, item) {
      const activities = [];
      if (item.hasHarvest) activities.push('Harvest');
      if (item.hasRoadConstruction) activities.push('Road Construction');
      if (item.hasWaterCrossing) activities.push('Water Crossing');

      return activities.join(', ');
    },
    shiftMobile() {
      const actionField = this.fields.pop();
      this.fields.unshift(actionField);
    },
    forceRerender() {
      this.tableKey += 1;
    },
  },
  created() {
    if (this.isExtraSmall) {
      // move actionField in front of basic fields
      this.shiftMobile();
    }
  },
};
</script>
